module.exports = __webpack_public_path__ + "static/FutureImages@2x-69cbc7030bb2f05f9ec1cf80b863a6b1.jpg";